import { render } from "./EditDiscussionProfileModeModal.vue?vue&type=template&id=2569e6ce&scoped=true"
import script from "./EditDiscussionProfileModeModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditDiscussionProfileModeModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditDiscussionProfileModeModal.vue?vue&type=style&index=0&id=2569e6ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2569e6ce"]])

export default __exports__